import { InstitutionView } from '../../../../../types/entity-types';
import { getInstitutionDetails } from '../../../utils/get-institution-details';

type InstitutionListProps = {
  institutions: InstitutionView[];
  onSelectInstitution: (institution: InstitutionView) => void;
};

export const InstitutionList = ({ institutions, onSelectInstitution }: InstitutionListProps) => {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
      {institutions.map((i) => {
        const { logo, name } = getInstitutionDetails(i);
        return (
          <div
            key={i.externalId}
            className="flex h-11 w-64 cursor-pointer items-center space-x-4 rounded-full bg-white p-2 shadow-xs transition-all duration-200 hover:shadow-md"
            onClick={() => onSelectInstitution(i)}
          >
            <img
              src={logo}
              alt={name}
              loading="eager"
              fetchpriority="high"
              className="h-8 w-8 rounded-full object-contain"
            />

            <h3 className="truncate text-sm font-medium text-black">{name}</h3>
          </div>
        );
      })}
    </div>
  );
};
